module.exports = __webpack_public_path__ + "static/media/5ece306801f347edab70db7c.96d9c1c6.png";